import Vue from 'vue'
import Vuex from 'vuex'
// 用户信息
import user from './user/userInfo.js'
import apply from './apply/apply.js'
import live from './live/live.js'
import other from './other/other.js'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    personalMeunAct: 'liveList' // 个人中心导航菜单栏默认选中
  },
  mutations: {
    // 刷新时获取存储的个人中心导航菜单信息
    initPersonalMeunAct: state => {
      try {
        const data = JSON.parse(localStorage.getItem('personalMeunAct'))
        state.personalMeunAct = data
      } catch (e) {}
    },
    // 修改个人中心导航菜单默认展开
    editPersonalMeunAct: (state, data) => {
      state.personalMeunAct = data
      localStorage.setItem('personalMeunAct', JSON.stringify(data))
    }
  },
  actions: {
  },
  modules: {
    user,
    apply,
    live,
    other
  }
})
